import { exports as emotionUseInsertionEffectWithFallbacks_cjsExports, __module as emotionUseInsertionEffectWithFallbacks_cjs } from '../../../../_virtual/emotion-use-insertion-effect-with-fallbacks.cjs2.js';
import { __require as requireEmotionUseInsertionEffectWithFallbacks_cjs_prod } from './emotion-use-insertion-effect-with-fallbacks.cjs.prod.js';
import { __require as requireEmotionUseInsertionEffectWithFallbacks_cjs_dev } from './emotion-use-insertion-effect-with-fallbacks.cjs.dev.js';

var hasRequiredEmotionUseInsertionEffectWithFallbacks_cjs;

function requireEmotionUseInsertionEffectWithFallbacks_cjs () {
	if (hasRequiredEmotionUseInsertionEffectWithFallbacks_cjs) return emotionUseInsertionEffectWithFallbacks_cjsExports;
	hasRequiredEmotionUseInsertionEffectWithFallbacks_cjs = 1;
	(function (module) {

		if (process.env.NODE_ENV === "production") {
		  module.exports = requireEmotionUseInsertionEffectWithFallbacks_cjs_prod();
		} else {
		  module.exports = requireEmotionUseInsertionEffectWithFallbacks_cjs_dev();
		}
} (emotionUseInsertionEffectWithFallbacks_cjs));
	return emotionUseInsertionEffectWithFallbacks_cjsExports;
}

export { requireEmotionUseInsertionEffectWithFallbacks_cjs as __require };
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.cjs.js.map
